import React from 'react';
import ContactForm from '../components/sections/ContactForm';
import ContentSection from '../components/sections/ContentSection';

const ContactPage: React.FC = () => {
  return (
    <>
      <div className="bg-primary-800 text-white py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl max-w-3xl">
            We're excited to hear from you and explore how AiDA can transform your business operations.
          </p>
        </div>
      </div>
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <ContentSection 
                title="Get in Touch"
                content="Whether you're interested in a demonstration, have questions about our technology, or want to discuss partnership opportunities, our team is ready to assist you.\n\nWe value your interest and aim to respond to all inquiries within 24 hours during business days."
              />
              
              <div className="mt-8">
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Business Inquiries</h3>
                <p className="text-gray-600 mb-6">
                  For business and sales inquiries, please contact our dedicated team at business@aida-inc.ai. Our business hours are Monday through Friday, 9:00 AM to 5:00 PM EST.
                </p>
                
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Partnership Opportunities</h3>
                <p className="text-gray-600 mb-6">
                  AiDA Inc. is actively seeking strategic partnerships to expand our ecosystem and enhance our offerings. If you're interested in exploring collaboration opportunities, please reach out to partnerships@aida-inc.ai with a brief overview of your organization and potential synergies.
                </p>
                
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Careers</h3>
                <p className="text-gray-600 mb-6">
                  Join our innovative team and help shape the future of AI-assisted customer engagement. We're always looking for talented individuals with an entrepreneurial mindset. Check our current openings or send your resume to careers@aida-inc.ai.
                </p>
                
                <h3 className="text-2xl font-bold mb-4 text-gray-800">Visit Us</h3>
                <address className="not-italic text-gray-600">
                  <p>Research Triangle Park, NC</p>
                  <p>United States</p>
                </address>
              </div>
            </div>
            
            <div>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
